import { enqueueSnackbar } from "_shared/_providers/snackbars/snackbars";
import type ProposalTemplate from "work/proposal-templates/proposal-template";

/**
 * Deletes one of the reader's templates and says whether it went, by snackbar and by the answer.
 *
 * Module scope, so the React Compiler sees no try/catch in the components that call it: the Create
 * from Template dialog and the Templates tab (#6261).
 */
export async function deleteTemplateNamed(
  template: ProposalTemplate,
  remove: (templateId: string) => Promise<unknown>,
): Promise<boolean> {
  try {
    await remove(template.id.value);
    enqueueSnackbar(`Deleted the proposal template ${template.name}.`, {
      variant: "success",
    });
    return true;
  } catch (error) {
    console.error("Failed to delete a proposal template", error);
    enqueueSnackbar(`Could not delete the proposal template ${template.name}. Please try again.`, {
      variant: "error",
    });
    return false;
  }
}
